<!-- eslint-disable max-len -->
<template>
  <aha-modal
    :title="title"
    @hide="$emit('hide')"
    action-position="justify-center"
  >
    <aha-multi-tabs
      @onChangeTab="onChangeTab"
      :tabTitles="tabNames"
      :defaultTabIndex="0"
    >
    </aha-multi-tabs>
    <KeepAlive>
      <component
        :name="'CopySlideTo' + tabContent"
        v-aha-emit-action.view
        class="mt-4"
        :is="tabContent"
        :presentationId="selectedPresentationId"
        @onLoading="onLoading"
        @onLoaded="onLoaded"
        @handlePresentationItemClick="handleSelectPresentation"
      >
        <template #interactive-button-section>
          <InsertAfterSlideCopy
            v-if="!arePresentationsLoading"
            :selectedPresentationId="selectedPresentationId"
            :areSlidesLoading="areSlidesLoading"
            :slides="slides"
            :selectedSlides="selectedSlides"
            @onChangeSelectedSlideOrder="onChangeSelectedSlideOrder"
            @onChangeIncludingResponseData="onChangeIncludingResponseData"
          />
          <ButtonSlideCopy
            v-if="!arePresentationsLoading"
            v-aha-emit-action
            :selectedPresentationId="selectedPresentationId"
            :isSlideCopying="isSlideCopying"
            @handleCopyButtonClick="() => handleCopyButtonClick([selectedPresentation])"
          />
        </template>
      </component>
    </KeepAlive>
  </aha-modal>
</template>

<script>
import SlideCopy from '@/components-v2/common/slide-copy/SlideCopy.vue'
import TabRecent from '@/components-v2/common/slide-copy/tabs/TabRecent.vue'
import TabPresentations from '@/components-v2/common/slide-copy/tabs/TabPresentations.vue'
import TabSharedPresentations from '@/components-v2/common/slide-copy/tabs/TabSharedPresentations.vue'

export default {
  components: {
    ...SlideCopy.components,
    TabRecent,
    TabPresentations,
    TabSharedPresentations,
  },
  extends: SlideCopy,
  data: () => ({
    tabContent: TabRecent.name,
    selectedPresentation: null,
  }),
  computed: {
    ...SlideCopy.computed,
    tabs() {
      return [
        TabRecent,
        TabPresentations,
        TabSharedPresentations,
      ]
    },
    tabNames() {
      return this.tabs.map((tab) => tab.title)
    },
  },
  methods: {
    ...SlideCopy.methods,
    getAllUserPresentationsAndFolders() {},
    onChangeTab(index) {
      this.tabContent = this.tabs[index]?.name
      this.selectedPresentationId = null
    },
    onLoading() {
      // call when loading data
      this.arePresentationsLoading = true
    },
    onLoaded() {
      // call when loaded data
      this.arePresentationsLoading = false
    },
    handleSelectPresentation(presentation) {
      this.selectedPresentation = presentation
      this.handlePresentationItemClick(presentation)
    },
  },
}
</script>

  <style lang="scss" scoped>
  </style>
